var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h4", [_vm._v("Paramètres des sondages")]),
      _vm._v(" "),
      _c(
        "vx-card",
        { staticClass: "mt-5", attrs: { title: "Trame des analyses" } },
        [
          _c("CampaignQuestionnaires", {
            attrs: { api: "/api/referentiel/campaign-questionnaires" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vx-card",
        { staticClass: "mt-5", attrs: { title: "Trame des synthèses" } },
        [
          _c("CampaignFields", {
            attrs: { api: "/api/referentiel/campaign-fields" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vx-card",
        { staticClass: "mt-5", attrs: { title: "Type de campagne" } },
        [
          _c("CampaignTypes", {
            attrs: { api: "/api/referentiel/campaign-types" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }